module.exports = __webpack_public_path__ + "img/csomagjaink__also_bg_2560.4c7ba6c0.jpg";